import { faInfoCircle, faWindowClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DateTime } from 'luxon';
import moment from 'moment';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Container,
  ListGroup,
  OverlayTrigger,
  Popover,
  Row,
  Toast,
} from 'react-bootstrap';
// import { useSelector } from 'react-redux';
import ScaleLoader from 'react-spinners/ScaleLoader';
import { useFranchiseeContext } from '../../context/Franchisee';
import { useLeadContext } from '../../context/Lead';
import { getPackageById } from '../../data/cleaningPackages';
import { pink500 } from '../../ui/colors';
import PaymentButton from '../PaymentButton';
import ToastWrapper from '../ToastWrapper';
// import styles from './styles'
interface BookingStickyFooterProps {
  tip?: any;
}
const BookingStickyFooter: React.FC<BookingStickyFooterProps> = ({
  tip = 0,
}: BookingStickyFooterProps) => {
  const pageName = useRouter().asPath;
  const { franchisee } = useFranchiseeContext();
  const { lead } = useLeadContext();
  const [price, setPrice] = useState<number | string>(0);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [serviceFee, setServiceFee] = useState<number>(0.0);
  const [tax, setTax] = useState<number | string>('0.00');

  const convertPackageDurationToHours = (duration) => {
    const durationRegex = /^P(?:(\d+)D)?T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/;

    if (!duration) {
      return 0;
    }
    if (durationRegex.test(duration)) {
      return moment.duration(duration).asHours();
    }
    const [hours, minutes, seconds] = duration.split(':').map(parseFloat);
    const decimalHours = hours + minutes / 60 + seconds / 3600;
    return decimalHours;
  };

  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  const dwtPackageIDs = [6312, 5395, 5708, 7354, 8479, 5708, 7729, 6979, 8104];
  const addToCart = () => {
    // console.log(`The lead is: ${lead}`);
    const packageId =
      typeof lead.package === 'string'
        ? parseInt(lead.package, 10)
        : lead.package;
    const selectedPackage = getPackageById(packageId);
  };
  useEffect(() => {
    let leadTotalPrice = (
      Number(lead.price) +
      Number(lead.tax ?? 0) +
      Number(lead.serviceFee ?? 0)
    ).toFixed(2);
    if (lead.watchedVideo) {
      leadTotalPrice = (Number(leadTotalPrice) - 10.0).toFixed(2);
    }
    if (lead.tip > 0) {
      leadTotalPrice = (Number(leadTotalPrice) + Number(lead.tip)).toFixed(2);
    }
    if (typeof lead?.totalPrice === 'string') {
      setPrice(leadTotalPrice);
      setLoading(true);
    } else {
      setPrice(leadTotalPrice ?? 0);
      setLoading(true);
    }
    setTimeout(() => setLoading(false), 800);
    // setLoading(false);
    switch (pageName) {
      case '/confirm/':
        break;
      case '/schedule/':
        setDisabled(
          lead.dateTime === null ||
            DateTime.fromISO(lead?.dateTime) <=
              DateTime.local().plus({ hours: 8 })
        );
        break;
      case '/book/':
      default:
        setDisabled(lead?.package === undefined);
        break;
    }
  }, [lead]);

  function checkLead() {
    if (
      lead?.squareFootage === 0 ||
      lead?.bathrooms === 0 ||
      lead?.bedrooms === 0 ||
      lead?.people === 0 ||
      lead?.package === null
    ) {
      return true;
    }
  }
  const openDate: any = DateTime.fromISO(franchisee.openDate, {
    setZone: true,
  });
  const theDate = new Date();
  const currentDate: any = DateTime.fromJSDate(theDate);

  useEffect(() => {
    setServiceFee(Number(lead.serviceFee));
    setTax(lead.tax);
  }, [lead]);

  const popover = (
    <Popover
      id='popover-basic'
      style={{
        background: '#fff',
        zIndex: 1021,
        marginBottom: '1rem',
      }}
    >
      <Popover.Content
        className='popover-basic-content'
        style={{
          width: '100%',
          maxWidth: '280px',
          borderRadius: '4px',
          boxShadow: 'rgb(0 0 0 / 15%) 0px 3px 8px',
        }}
      >
        {lead.totalPrice && (
          <Col style={{ padding: '1rem 1.5rem' }}>
            <div className='d-flex justify-content-center'>
              <FontAwesomeIcon
                icon={faWindowClose}
                style={{
                  color: '#D4357F',
                }}
                className='ml-2'
                onClick={() => {
                  document.body.click();
                }}
              />
            </div>
            <Row style={{ marginRight: '0' }}>
              {typeof lead.price === 'string' ? (
                <Col xs={12} className='d-flex justify-content-between'>
                  <p className='ml-3'>Price:</p>
                  <p>${Number(lead.price).toFixed(2)}</p>
                </Col>
              ) : (
                <Col xs={12} className='d-flex justify-content-between'>
                  <p className='ml-3'>Price:</p>
                  <p>${Number(lead.price).toFixed(2)}</p>
                </Col>
              )}
              {lead.watchedVideo && (
                <Col xs={12} className='d-flex justify-content-between'>
                  <p className='ml-3'>Discount:</p>
                  <p>-$10.00</p>
                </Col>
              )}
              {serviceFee > 0 && (
                <>
                  {' '}
                  <Col xs={12} className='d-flex justify-content-between'>
                    <p className='ml-3'>Service Fee:</p>
                    <p>${serviceFee.toFixed(2)}</p>
                  </Col>
                  <Col className='mb-2'>
                    {' '}
                    <div
                      style={{
                        // padding: '3px 10px',
                        fontSize: '10px',
                        color: '#9e9e9e',
                        width: '51%',
                      }}
                      className='ml-3'
                    >
                      This service fee helps us operate Two Maids.
                    </div>
                  </Col>
                </>
              )}{' '}
              {(tip > 0 || lead.tip > 0) && (
                <Col xs={12} className='d-flex justify-content-between'>
                  <p className='ml-3'>Tip:</p>
                  <p>${tip > 0 ? tip : lead.tip}</p>
                </Col>
              )}
              {Number(tax) > 0 && (
                <>
                  <Col xs={12} className='d-flex justify-content-between'>
                    <p className='ml-3'>Estimated Tax:</p>
                    <p>$ {Number(tax).toFixed(2)}</p>
                  </Col>
                  <Col className='mb-2'>
                    {' '}
                    <div
                      style={{
                        // padding: '3px 10px',
                        fontSize: '10px',
                        color: '#9e9e9e',
                        width: '51%',
                      }}
                      className='ml-3'
                    >
                      Finalized tax will be shown on your oder receipt.
                    </div>
                  </Col>
                </>
              )}
              <Col
                xs={12}
                className='d-flex justify-content-between border-top border-gray'
                style={{ paddingTop: '1rem' }}
              >
                <p className='ml-3'>Total:</p>
                <p className='font-weight-bold'>
                  $
                  {lead.tip == 0 && tip > 0
                    ? (Number(price) + Number(tip)).toFixed(2)
                    : Number(price).toFixed(2)}
                </p>
              </Col>
            </Row>
          </Col>
        )}
      </Popover.Content>
    </Popover>
  );

  const popover_dwt = (
    <Popover
      id='popover-basic'
      style={{
        background: '#fff',
        zIndex: 1021,
        marginBottom: '1rem',
      }}
    >
      <Popover.Content
        className='popover-basic-content'
        style={{
          width: '100%',
          maxWidth: '280px',
          borderRadius: '4px',
          boxShadow: 'rgb(0 0 0 / 15%) 0px 3px 8px',
        }}
      >
        <p style={{ padding: '15px' }}>
          A team of 2 people and we will be there for
          {` ${convertPackageDurationToHours(lead.duration)} 
           hours.`}
        </p>
      </Popover.Content>
    </Popover>
  );

  return (
    <>
      <div
        className='sticky-cta sticky-cta--book'
        style={{ maxWidth: '100%' }}
        data-persistent
      >
        <Container>
          <Row className='justify-content-center'>
            <Col xs={12} md={11} lg={10}>
              <Row className='justify-content-center'>
                <Col xs={12} lg={10} xl={9}>
                  <Row className='justify-content-md-between align-items-center sticky-footer-content-container'>
                    <Col xs='auto' className='estimated-price-col'>
                      <div className='book__total-cost'>
                        {(lead.totalPrice > 0) && (
                          <strong>Estimated Price</strong>
                        )}
                        <div>
                          <span
                            className='book__total h3'
                            style={{ position: 'relative' }}
                          >
                            {loading && (
                              <ScaleLoader
                                height={24}
                                width={10}
                                color={pink500}
                                loading={loading}
                              />
                            )}
                            {tip <= 0 &&
                              !loading &&
                              `$${
                                !isNaN(Number(lead.totalPrice))
                                  ? Number(lead.totalPrice).toFixed(2)
                                  : '--'
                              }`}
                            {tip > 0 &&
                              !loading &&
                              `$${
                                !isNaN(Number(lead.totalPrice))
                                  ? Number(lead.totalPrice).toFixed(2)
                                  : '--'
                              }`}
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'baseline',
                                justifyContent: 'center',
                              }}
                            >
                              {lead.package == 1 && lead.duration && (
                                <>
                                  <span
                                    style={{
                                      fontSize: '18px',
                                      paddingRight: '2px',
                                    }}
                                  >
                                    Duration:{' '}
                                    {convertPackageDurationToHours(
                                      lead.duration
                                    )}{' '}
                                    Hours
                                  </span>
                                  <OverlayTrigger
                                    trigger={['click', 'focus']}
                                    overlay={popover_dwt}
                                    rootClose
                                  >
                                    <span>
                                      <div
                                        style={{
                                          cursor: 'pointer',
                                          fontSize: '12px',
                                          color: '#D4357F',
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faInfoCircle} />
                                      </div>
                                    </span>
                                  </OverlayTrigger>
                                </>
                              )}
                            </div>

                            {price > 0 && (
                              <OverlayTrigger
                                trigger={['click', 'focus']}
                                overlay={popover}
                                rootClose
                              >
                                <div className='sticky-footer-lightbox'>
                                  <hr />
                                  <div
                                    style={{
                                      cursor: 'pointer',
                                      fontSize: '12px',
                                      color: '#D4357F',
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faInfoCircle} />
                                  </div>
                                  <hr />
                                </div>
                              </OverlayTrigger>
                            )}
                          </span>
                        </div>
                      </div>
                    </Col>
                    <Col
                      xs='auto'
                      className='sticky-cta__phone d-flex mx-auto ml-sm-auto mr-sm-0 mb-sm-3 cta-schedule-button'
                    >
                      {pageName === '/book/' && (
                        <>
                          {franchisee.teamCount > 0 ||
                          franchisee.fauxfranchisee > 1 ||
                          (franchisee.teamCount > 0 &&
                            currentDate > openDate) ? (
                            <Link href='/schedule/'>
                              <Button disabled={disabled} data-next-step>
                                Schedule Cleaning
                              </Button>
                            </Link>
                          ) : (
                            <Link href='/pre-open/'>
                              <Button disabled={disabled} data-next-step>
                                Confirm Info
                              </Button>
                            </Link>
                          )}
                        </>
                      )}
                      {pageName === '/schedule/' && (
                        <>
                          <Link href='/confirm/'>
                            <Button
                              onClick={() => addToCart()}
                              disabled={disabled}
                              data-next-step
                            >
                              REVIEW & PURCHASE
                            </Button>
                          </Link>
                        </>
                      )}
                      {pageName === '/confirm/' && <PaymentButton />}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastWrapper>
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Body>
            <ListGroup>
              <ListGroup.Item variant='primary'>
                <strong>In Development</strong>
              </ListGroup.Item>
            </ListGroup>
          </Toast.Body>
        </Toast>
      </ToastWrapper>
    </>
  );
};
BookingStickyFooter.defaultProps = {
  // add booking sticky footer default props here
  // className: null,
};
export default BookingStickyFooter;
